import { Pipe, PipeTransform } from '@angular/core';
import { IAdditionalEmails } from '../interfaces';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';

@Pipe({ name: 'isParkerMassUpdateError', pure: true })
export class IsParkerErrorOnMassUpdate implements PipeTransform {
  constructor(private parkerStateService: ParkerStateService) {}

  transform(parkerId: string): boolean {
    let isError: boolean = false;
    let ii: number = 0;
    for (ii = 0; ii < this.parkerStateService.parkerUpdateList.length; ii++) {
      if (
        parkerId == this.parkerStateService.parkerUpdateList[ii].parkerId &&
        this.parkerStateService.parkerUpdateList[ii].processed === false
      ) {
        isError = true;
      }
    }

    return isError;
  }
}
